module.exports = __webpack_public_path__ + "img/eye-icon.6030e1ae.svg";